<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
<v-container
        fill-height
        fluid
        grid-list-xl
        xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          title="قائمة المراجعين"
          text="تفاصيل العينات و معلومات المراجعين الشخصية"
        >

          <v-dialog v-model="barcodeSearch" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">بحث على رقم العينة عن طريق الباركود</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                      <v-col cols="12">
                        <v-text-field
                            outlined
                            label="رقم العينة"
                            v-model="cardnum"
                            @keyup.enter="getPatients(cardnum)"
                            ref="barcodeinput"
                        ></v-text-field>
                        <v-btn
                            @click="getPatients(cardnum)"
                            large
                            block
                            color="primary">
                            <v-icon class="ml-1">mdi-magnify</v-icon>
                            بحث
                            </v-btn>
                      </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>


          <v-container>
            <v-row>
              <v-col cols="12" md="3" xs="6" sm="6">
                <v-btn large  color="green" dark @click="addNewPatient">
                  <v-icon class="ml-1">mdi-account-plus</v-icon>
                  إضافة مراجع جديد
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" xs="6" sm="6">
                <v-btn large  color="blue" dark @click="openBarcodeDialog()">
                  <v-icon class="ml-1">mdi-magnify</v-icon>
                  بحث عن طريق رقم العينة (باركود)</v-btn>
              </v-col>

              <v-col cols="12" md="6" xs="12" sm="12">
                <v-text-field
                        filled
                        v-model="fullname"
                        append-icon="mdi-magnify"
                        label="بحث على الاسم ..."
                        single-line
                        v-on:key.enter="getPatients"
                        hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-container>


          <v-data-table
                  :loading="isloading"
                  :loading-text="loadingtext"
                  :headers="headers"
                  :search="fullname"
                  :items="items"
          >
            <template v-slot:top>

                <v-dialog v-model="dialog" max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">قائمة الخيارات</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="6" sm="12" md="6" xs="12">
                            <v-card>
                              <v-card-title>
                                    تعديل معلومات المراجع
                              </v-card-title>
                              <v-card-subtitle>
                                يمكنك تعديل المعلومات الشخصية للمراجع مثل الاسم، تاريخ الميلاد الخ.
                              </v-card-subtitle>
                              <v-card-actions>
                                  <v-btn color="purple" dark @click="editpatient" block>
                                    تعديل المعلومات الشخصية
                                  </v-btn>
                              </v-card-actions>
                            </v-card>

                          </v-col>
                          <v-col cols="6" sm="12" md="6">
                            <v-card>
                              <v-card-title>
                                جدول المتابعة
                              </v-card-title>
                              <v-card-subtitle>
                                من خلال هذه الخاصية يمكنك تحديد مواعيد المراجعة للمريض و تثبيت العلاجات و التشخيص في كل مراجعة
                              </v-card-subtitle>

                              <v-card-actions>
                                <v-btn color="green" dark @click="gotoFollowUp()" block>
                                  المتابعة
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="12" md="6">
                            <v-card>
                              <v-card-title>
                               تعديل معلومات العينات
                              </v-card-title>
                              <v-card-subtitle>
                               يرجى اختيار رقم العينة المراد تعديل معلوماتها من الإختيارات ادناه:
                              </v-card-subtitle>
                              <v-card-actions v-for="card in cards" :key="card.id">
                                <v-btn color="primary" dark @click="editcard(card)" block>
                                {{ card.barcode }}
                                </v-btn>
                              </v-card-actions>

                              <v-card-actions>
                                <v-btn color="green" dark @click="newcard" block>إضافة عينة جديدة</v-btn>
                              </v-card-actions>


                            </v-card>
                          </v-col>
                          <v-col cols="6" sm="12" md="6">
                            <v-card>
                              <v-card-title>
                                قائمة الطلبات
                              </v-card-title>
                              <v-card-subtitle>
                                يمكنك إرسال الطلب الى المركز الصحي من خلال هذه القائمة
                              </v-card-subtitle>
                              <v-card-actions>
                                <v-btn color="green" dark @click="goToAction" block>
                                  فتح طلب جديد
                                </v-btn>
                              </v-card-actions>
                              <v-card-actions>
                                <v-btn color="blue" dark @click="goToListActions" block>
                                  قائمة الطلبات
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">اغلاق</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
            </template>

            <template v-slot:item.barcode="{ item }">
              <div>{{ item.cards ? item.cards[0].barcode : 'N/A' }}</div>
            </template>

            <template v-slot:item.healthcenter="{ item }">
              <div>{{ item.cards ? item.cards[0].healthcenter : 'N/A' }}</div>
            </template>

            <template v-slot:item.takendate="{ item }">
              <div>{{ item.cards ? item.cards[0].takendate : 'N/A' }}</div>
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn
                      primary
                      dark
                      center
                      @click="editItem(item)">
              <v-icon
                      medium>
                mdi-pencil
              </v-icon>
              </v-btn>
              <v-btn
                     warning
                     dark
                     @click="deleteItem(item)">
              <v-icon
                      medium
              >
                mdi-delete
              </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {__HTTP,FormHeader,__HAS_PERM} from "@/utils/utils";

export default {
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    openBarcodeDialog(){
      this.barcodeSearch = true;
      setTimeout(() => this.$refs.barcodeinput.$refs.input.focus(), 200);
    },
    getPatients(barcodenumber) {

        this.items = [];
        barcodenumber = (typeof barcodenumber !== 'undefined') ?  barcodenumber : ''
        __HTTP("?do=getpatients&barcode=" + barcodenumber,{},FormHeader,(res) => {
          this.isloading = false;
          this.barcodeSearch = false;
          this.cardnum = '';
          this.items = res
      })
    },
    editItem (item) {
      //this.editedIndex = this.items.indexOf(item)
      //this.editedItem = Object.assign({}, item)
      this.toBeEdit = item
      this.cards = item.cards
      //this.$store.dispatch('setEditDialogState',true)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.items.indexOf(item)
      let c = confirm('Are you sure you want to delete this item?');
      if (c) {
        __HAS_PERM(4,this.$store.state.loggedUser.id,() => {
          __HTTP("?do=delete",{type: "patient",id: item.id},FormHeader,() => {
            this.items.splice(index, 1)
          })
        });
      }
    },
    editpatient() {

      this.$router.push({path: '/edit-patient', query: {pid: this.toBeEdit.id}})
    },
    editcard(card) {
    this.$router.push({path: '/edit-card', query: {pid: card.id}})
    },
    newcard() {
      this.$router.push({path: '/new-card', query: {pid: this.toBeEdit.id, pname: this.toBeEdit.fullname}})
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    gotoFollowUp() {
      this.$router.push({name: 'ListFollowup', params: {id: this.toBeEdit.id, pname: this.toBeEdit.fullname}})
    },
    goToAction() {
      this.$router.push({name: 'NewAction', params: {id: this.toBeEdit.id, pname: this.toBeEdit.fullname}})
    },
    goToListActions() {
      this.$router.push({name: 'ListActions', params: {id: this.toBeEdit.id, pname: this.toBeEdit.fullname}})
    },

    addNewPatient() {
      this.$router.push({name: 'NewPatient', params: {}})
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.desserts.push(this.editedItem)
      }
      this.close()
    },
  },
  created() {
    this.getPatients()
  },
  data: () => ({
    isloading: true,
    barcodeSearch: false,
    loadingtext: "يرجى الانتظار جاري جلب البيانات",
    dialog: false,
    cardnum: '',
    toBeEdit: null,
    fullname: '',
    cards: [],
    headers: [
      {
        sortable: true,
        text: 'الإسم',
        value: 'fullname',
        align: 'right'
      },
      {
        sortable: true,
        text: 'رقم العينة',
        value: 'barcode',
        align: 'right'
      },
      {
        sortable: true,
        text: 'المحافظة',
        value: 'province_text',
        align: 'right'
      },
      {
        sortable: true,
        text: 'الجنس',
        value: 'sex_text',
        align: 'right'
      },
      {
        sortable: true,
        text: 'المركز الصحي',
        value: 'healthcenter',
        align: 'right'
      },
      {
        sortable: true,
        text: 'تاريخ اخذ العينة',
        value: 'takendate',
        align: 'right'
      },
      { text: 'الادوات', value: 'action', sortable: false },
    ],
    items: [

    ]
  })
}
</script>
